import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { toast } from "react-toastify";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const Notifications = () => {
  document.title = "Notifications";

  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  // console.log(selectedUserId);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="إدارة الإشعارات" />
          <Row>
            <Col lg={12}>
              <Card style={{ borderRadius: "16px" }}>
                <CardBody>
                  {/* Tabs */}
                  <Nav tabs className="mb-4">
                    <NavItem>
                      <NavLink
                        className={activeTab === "1" ? "active" : ""}
                        onClick={() => toggleTab("1")}
                        style={{ cursor: "pointer" }}
                      >
                        إشعار عام
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={activeTab === "2" ? "active" : ""}
                        onClick={() => toggleTab("2")}
                        style={{ cursor: "pointer" }}
                      >
                        إشعار لمستخدم
                      </NavLink>
                    </NavItem>
                  </Nav>

                  {/* Content */}
                  <TabContent activeTab={activeTab}>
                    {/* ===== TAB 1: إشعار عام ===== */}
                    <TabPane tabId="1">
                      <div className="p-3">
                        <h6 className="mb-4 text-muted">
                          إرسال إشعار لجميع المستخدمين
                        </h6>

                        <div className="mb-3">
                          <label className="form-label">العنوان</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="عنوان الإشعار"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">الرسالة</label>
                          <textarea
                            className="form-control"
                            rows="4"
                            placeholder="نص الرسالة"
                          />
                        </div>

                        <div className="text-end">
                          <Button color="success">
                            <i className="ri-send-plane-2-line me-1"></i>
                            إرسال
                          </Button>
                        </div>
                      </div>
                    </TabPane>

                    {/* ===== TAB 2: إشعار لمستخدم ===== */}
                    <TabPane tabId="2">
                      <div className="p-3">
                        <h6 className="mb-4 text-muted">
                          إرسال إشعار لمستخدم معين
                        </h6>

                        <div className="mb-3">
                          <label className="form-label">معرف المستخدم</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="user id"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">العنوان</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="عنوان الإشعار"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">الرسالة</label>
                          <textarea
                            className="form-control"
                            rows="4"
                            placeholder="نص الرسالة"
                          />
                        </div>

                        <div className="text-end">
                          <Button color="success">
                            <i className="ri-send-plane-2-line me-1"></i>
                            إرسال
                          </Button>
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Confirm Toggle Block Modal */}
      {/* <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الإجراء
        </ModalHeader>
        <ModalBody>
          <div className="mt-2 text-center">
            <i
              className={`ri-information-line display-3 ${isBlockedStatus ? "text-success" : "text-danger"}`}
            ></i>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>
              <p className="text-muted mx-4 mb-0">
                هل تريد حقاً {isBlockedStatus ? "إلغاء حظر" : "حظر"} هذا
                المستخدم؟
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>
            <Button
              color={isBlockedStatus ? "success" : "danger"}
              onClick={confirmToggleBlock}
            >
              نعم، {isBlockedStatus ? "إلغاء الحظر" : "إتمام الحظر"}
            </Button>
          </div>
        </ModalFooter>
      </Modal> */}
    </React.Fragment>
  );
};

export default Notifications;
